import { FormatNumber2 } from "../utility/functions/formatNumber";

export const VoucherEntryColumns = (w) => {
  const width = w;
  const width1 = Number(Number(width / 5).toFixed(0));
  const width2 = Number(Number(width / 2).toFixed(0));
  const width3 = Number(Number(width / 8).toFixed(0));

  const columns = [
    {
      field: "ACCOUNT_NO",
      accessor: "ACCOUNT_NO",
      type: "string",
      headerAlign: "center",
      width: width1,
      align: "left",
      headerClassName: "super-app-theme--header",
      editable: true,
      renderCell: (param) => {
        return <div>{param.value}</div>;
      },
      renderHeader: (params) => (
        <div className="text-white" style={{ fontSize: 13 }}>
          Account No.
        </div>
      ),
    },

    {
      field: "ACCOUNT_NAME",
      accessor: "ACCOUNT_NAME",
      type: "string",
      headerAlign: "center",
      align: "left",

      width: width2,

      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return (
          <div className={` h-full w-full  items-center  `}>
            {params.value}{" "}
            <div className="italic text-gray-500">
              {params.row.original.CURRENT_BALANCE2 > 0 &&
                " ( " +
                  params.row.original.CURRENT_BALANCE2 +
                  " " +
                  params.row.original.CURRENT_BALANCE_TYPE +
                  " ) "}
            </div>
          </div>
        );
      },
      renderHeader: (params) => (
        <div className="text-white" style={{ fontSize: 13 }}>
          Account Name
        </div>
      ),
    },
    {
      field: "DEBIT",
      accessor: "DEBIT",
      type: "number",
      headerAlign: "center",
      align: "right",
      editable: true,
      formatNumber2: true,
      width: width3,

      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return (
          <div className={` h-full w-full flex items-center  `}>
            {params.value}
          </div>
        );
      },
      renderHeader: (params) => (
        <div className="text-white" style={{ fontSize: 13 }}>
          Debit
        </div>
      ),
    },
    {
      field: "CREDIT",
      accessor: "CREDIT",
      type: "number",
      isLast: true,
      headerAlign: "center",
      align: "right",

      width: Number(width) - (width1 + width2 + width3 + 100),
      editable: true,

      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return (
          <div className={` h-full w-full flex items-center  `}>
            {params.value ? FormatNumber2(params.value) : ""}
          </div>
        );
      },
      renderHeader: (params) => (
        <div className="text-white" style={{ fontSize: 13 }}>
          Credit
        </div>
      ),
    },
  ];

  return columns;
};
export const AccountLedgerColumns = (w) => {
  const width = w > 1000 ? 900 : 800;

  const columns = [
    {
      field: "TAX_ACCOUNT_NO",
      accessor: "TAX_ACCOUNT_NO",
      type: "text",
      headerAlign: "center",
      align: "left",
      editable: true,

      width: Number(width / 7),

      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return (
          <div className={` h-full w-full flex items-center  `}>
            {params.value}
          </div>
        );
      },
      renderHeader: (params) => (
        <div className="text-white" style={{ fontSize: 13 }}>
          Account Number
        </div>
      ),
    },
    {
      field: "TAX_ACCOUNT_NAME",
      accessor: "TAX_ACCOUNT_NAME",
      type: "string",
      headerAlign: "center",
      align: "left",

      width: Number(width / 3),

      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return (
          <div className={` h-full w-full flex items-center  `}>
            {params.value}
          </div>
        );
      },
      renderHeader: (params) => (
        <div className="text-white" style={{ fontSize: 13 }}>
          Account Name
        </div>
      ),
    },

    {
      field: "PERCENTAGE",
      accessor: "PERCENTAGE",
      type: "number",
      headerAlign: "center",
      align: "left",

      width: Number(width / 6),
      editable: true,
      isLast: true,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return (
          <div className={` h-full w-full flex items-center  `}>
            {params.value}
          </div>
        );
      },
      renderHeader: (params) => (
        <div className="text-white" style={{ fontSize: 13 }}>
          Percentage
        </div>
      ),
    },
  ];

  return columns;
};
